'use client';

import { Tabs } from '@chakra-ui/react';

import { useSavedJobListQuery } from '@/modules/job/application';
import { SavedJobList } from '@/modules/job/presentation/components';
import { savedJobListItemDtoToVM, useRemoveJobHandler } from '@/modules/job/view-models';

export const SavedJobListContainer = () => {
	const { data, isLoading } = useSavedJobListQuery();
	const savedJobs = data?.savedJobs || [];
	const saveJobList = savedJobs.map(savedJobListItemDtoToVM);
	const activeInterestedJob = saveJobList.filter(job => job.status === 'RECRUITING');
	const closingInterestedJobs = saveJobList.filter(job => job.status === 'CLOSING_SOON');
	const closedInterestedJobs = saveJobList.filter(job => job.status === 'CLOSED');

	const removeJobHandler = useRemoveJobHandler();

	return (
		<Tabs.Root defaultValue="recruiting" gap={0} variant="outline">
			<Tabs.List>
				<Tabs.Trigger _selected={{ color: 'primary.100' }} value="recruiting">Recruiting</Tabs.Trigger>
				<Tabs.Trigger _selected={{ color: 'primary.100' }} value="closing">Closing Soon</Tabs.Trigger>
				<Tabs.Trigger _selected={{ color: 'primary.100' }} value="closed">Closed</Tabs.Trigger>
			</Tabs.List>
			<Tabs.Content p="md" value="recruiting">
				<SavedJobList
					interestedJobs={activeInterestedJob}
					isLoading={isLoading}
					onClickDelete={removeJobHandler.execute}
				/>
			</Tabs.Content>
			<Tabs.Content p="md" value="closing">
				<SavedJobList
					interestedJobs={closingInterestedJobs}
					isLoading={isLoading}
					onClickDelete={removeJobHandler.execute}
				/>
			</Tabs.Content>
			<Tabs.Content p="md" value="closed">
				<SavedJobList
					interestedJobs={closedInterestedJobs}
					isLoading={isLoading}
					onClickDelete={removeJobHandler.execute}
				/>
			</Tabs.Content>
		</Tabs.Root>
	);
};
